import React, { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import loadComponent from 'src/utils/loadMFE'
import RouteContainer from 'src/components/App/RouteContainer'

const AcademyCreateForm = React.lazy(() => loadComponent('traiwiss', 'AcademyCreateForm'))

export function AcademyCreateRoute() {
    const navigate = useNavigate()

    const onCreate = useCallback(() => {
        navigate('/academies')
    }, [navigate])

    const onClose = useCallback(() => {
        navigate('/academies')
    }, [navigate])

    return (
        <RouteContainer>
            <AcademyCreateForm onCreated={onCreate} onClosed={onClose} />
        </RouteContainer>
    )
}
